import { axiosClient } from './axiosClient';

export const messagingService = {
  // Conversations
  listConversations: (params = {}) => axiosClient.get('/messaging/conversations/', { params }),
  retrieveConversation: (id) => axiosClient.get(`/messaging/conversations/${id}/`),
  createConversation: (payload) => axiosClient.post('/messaging/conversations/', payload),
  
  // Conversation actions
  assignConversation: (id, userId) => axiosClient.post(`/messaging/conversations/${id}/assign/`, { user_id: userId }),
  closeConversation: (id, reason = '') => axiosClient.post(`/messaging/conversations/${id}/close/`, { reason }),
  reopenConversation: (id) => axiosClient.post(`/messaging/conversations/${id}/reopen/`),
  archiveConversation: (id) => axiosClient.post(`/messaging/conversations/${id}/archive/`),
  unarchiveConversation: (id) => axiosClient.post(`/messaging/conversations/${id}/unarchive/`),
  sendMessage: (id, content) => axiosClient.post(`/messaging/conversations/${id}/message/`, { content }),
  
  // Stats
  getStats: () => axiosClient.get('/messaging/conversations/stats/'),
  
  // My conversations (for salon managers)
  getMyConversations: (params = {}) => axiosClient.get('/messaging/conversations/my_conversations/', { params }),
  getSupportSalons: () => axiosClient.get('/messaging/conversations/support_salons/'),
  
  // Messages
  listMessages: (params = {}) => axiosClient.get('/messaging/messages/', { params }),
  markMessageAsRead: (id) => axiosClient.post(`/messaging/messages/${id}/mark_read/`),
  markAllMessagesAsRead: (conversationId) => axiosClient.post('/messaging/messages/mark_all_read/', { conversation_id: conversationId }),

  // Direct client-to-salon conversations
  listClientConversations: (params = {}) => axiosClient.get('/messaging/client-conversations/', { params }),
  listSalonClientConversations: (salonId, params = {}) => axiosClient.get('/messaging/client-conversations/', { params: { ...params, salon: salonId } }),
  retrieveClientConversation: (id, params = {}) => axiosClient.get(`/messaging/client-conversations/${id}/`, { params }),
  createClientConversation: (payload) => axiosClient.post('/messaging/client-conversations/', payload),
  sendClientConversationMessage: (id, content, params = {}) => axiosClient.post(`/messaging/client-conversations/${id}/message/`, { content }, { params }),
  markClientConversationRead: (id, params = {}) => axiosClient.post(`/messaging/client-conversations/${id}/mark-read/`, {}, { params }),
  assignClientConversation: (id, userId, params = {}) => axiosClient.post(`/messaging/client-conversations/${id}/assign/`, { user_id: userId }, { params }),
  closeClientConversation: (id, params = {}) => axiosClient.post(`/messaging/client-conversations/${id}/close/`, {}, { params }),
  reopenClientConversation: (id, params = {}) => axiosClient.post(`/messaging/client-conversations/${id}/reopen/`, {}, { params }),
  listClientConversationAssignees: (id, params = {}) => axiosClient.get(`/messaging/client-conversations/${id}/assignees/`, { params }),
  getClientChatSettings: (salonId) => axiosClient.get(`/messaging/client-chat-settings/${salonId}/`),
  updateClientChatSettings: (salonId, payload) => axiosClient.patch(`/messaging/client-chat-settings/${salonId}/`, payload),
};
